<template>
  <div id="app">
    <ComAppTopTip/>
    <ComWaiting/>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#app{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue